import setPlainTextEditorSelection from '../actions/setPlainTextEditorSelection';
import updateContent from '../actions/updateContent';
import EditorViewState from '../store/schema/EditorViewState';
import { addContentOperator, removeContentOperator } from '../utils/operateContent';
import { keydownHandler } from 'owa-hotkeys';
import * as React from 'react';

export interface PlainTextEditorProps {
    viewState: EditorViewState;
    plainTextPlaceholder: string;
    onFocus?: () => void;
    plainTextEditorRefCallback?: (ref: HTMLTextAreaElement) => void;
    classNames?: string;
}

export default class PlainTextEditor extends React.Component<PlainTextEditorProps, {}> {
    private textArea: HTMLTextAreaElement;

    render() {
        const { classNames, plainTextPlaceholder, onFocus } = this.props;

        return (
            <textarea
                ref={this.refCallback}
                className={classNames}
                placeholder={plainTextPlaceholder || ''}
                onFocus={onFocus}
                onChange={this.onChange}
            />
        );
    }

    componentDidMount() {
        const viewState = this.props.viewState;
        const { content, selectionStart, selectionEnd } = viewState;

        addContentOperator(viewState, null /* htmlEditor */, this.textArea /* plainTextEditor */);

        if (this.textArea) {
            // Browsers like Edge will move the selection start and end to
            // the end of the content when the value of the input is updated
            // Save these values so we can maintain the initial selection
            const initialStart = this.textArea.selectionStart;
            const initialEnd = this.textArea.selectionEnd;
            this.textArea.value = content;
            this.textArea.selectionStart = selectionStart != null ? selectionStart : initialStart;
            this.textArea.selectionEnd = selectionEnd != null ? selectionEnd : initialEnd;
        }
    }

    componentWillUnmount() {
        removeContentOperator(this.props.viewState);
    }

    @keydownHandler(
        'ctrl+z',
        true /*stopPropagation*/,
        false /*preventDefault*/,
        true /*allowHotkeyOnTextFields*/
    )
    stopUndoPropagation() {
        // do nothing -- this keydown handler stops propagation so that the mailmodule
        // does not eat the undo action & the browser's native Undo functionality can work.
    }

    focus() {
        if (this.textArea) {
            this.textArea.focus();

            const viewState = this.props.viewState;
            const { selectionStart, selectionEnd } = viewState;
            if (selectionStart != null && selectionEnd != null) {
                this.textArea.selectionStart = selectionStart;
                this.textArea.selectionEnd = selectionEnd;

                // reset values in view state
                setPlainTextEditorSelection(
                    viewState,
                    null /* selectionStart */,
                    null /* selectionEnd */
                );
            }
        }
    }

    private refCallback = (ref: HTMLTextAreaElement) => {
        this.textArea = ref;

        if (this.props.plainTextEditorRefCallback) {
            this.props.plainTextEditorRefCallback(ref);
        }
    };

    private onChange = () => {
        updateContent(this.props.viewState, this.textArea.value);
    };
}
